export const subscriptionApiErrorMessages = {
  currentBillingCycleStatusIsUnknown: 'Unable to change next order date',
  rebillInProgress: 'Unable to change next order date: rebill in progress',
  paymentFailed: 'There was a billing Issue. Please update your payment method.'
};
